import React from 'react';
import Experience from './experience'
import Expertise from './expertise'
// import Skills from './skills'
import Portfolio from './portfolio'
import Education from './education'
import Contact from './contact'
import Footer from './footer'

function RightBlock() {
	return(
		<div class="right-col-block blocks">
			<div class="theiaStickySidebar">
				<Experience></Experience>
				<Expertise></Expertise>
				{/* <Skills></Skills> */}
				<Portfolio></Portfolio>
				<Education></Education>
				<Contact></Contact>
				<Footer></Footer>
			</div>
		</div>
	)
}

export default RightBlock;